export const TRAIN_DERAILMENT = 'TRAIN_DERAILMENT';
export const ACTIVE_ASSAILANT = 'ACTIVE_ASSAILANT';
export const TEST_TRAIN_DERAILMENT = 'TEST_TRAIN_DERAILMENT';
